/** Constants mirrored from DrawMapUtil.java */

export const START_INDENT = 10;
export const DRAW_EDGE_INDENT = 7;
export const MIN_DRAW_WASTE = 7;
export const HATCHING_STEP_CUT_OFF = 50;
export const HATCHING_STEP_WASTE = 30;

export const DASHED_LINE = 100;
export const INDENT_DASHED_LINE = 50;

/** Same as BufferedImage in DrawMapUtil for horizontal / NOT_TEXTURAL */
export const JAVA_CANVAS_WIDTH = 2828;
export const JAVA_CANVAS_HEIGHT = 2092;
/** Vertical structure uses 2092 x 2828 */
export const JAVA_CANVAS_WIDTH_VERTICAL = 2092;
export const JAVA_CANVAS_HEIGHT_VERTICAL = 2828;

/** relativeNumberTurns → fill (RGB; alpha via material opacity) */
export const TURN_COLORS = [
    '#1639E5', // 0
    '#09B432', // 1
    '#E59416', // 2
    '#EA1E17', // 3+
];
export const DROP_COLOR = '#17E3EA';
export const DETAIL_OPACITY = 184 / 255; // Java Color alpha 184

export const HATCH_COLOR_CUT_OFF = '#008000';
export const HATCH_COLOR_WASTE = '#0000FF';
/** Fainter than solid Java color — PNG antialias looks pale when scaled down */
export const HATCH_OPACITY = 0.22;
export const HATCH_LINE_WIDTH = 1;

export const CUT_COLOR = '#FF0000';
export const SHEET_OUTER_COLOR = '#0000FF';
/** Soften only the sheet frame; detail strokes stay dark like the PNG */
export const SHEET_INNER_COLOR = '#8A8A8A';
export const DETAIL_OUTLINE_COLOR = '#1A1A1A';
/** Cut-off border: light gray, drawn inset so it does not sit on kerf dashes */
export const CUTOFF_OUTLINE_COLOR = '#B8B8B8';
export const CUTOFF_OUTLINE_INSET = 2;
/** Java: startStroke=4, basicStroke=2 — world units so gaps match PNG at any zoom */
export const SHEET_OUTER_LINE_WIDTH = 4;
export const OUTLINE_LINE_WIDTH = 2;
export const CUT_LINE_WIDTH = 2;
export const EDGE_LINE_WIDTH = 2;
